// Rótulos e ordem oficial dos capítulos/sub-etapas do PMAU, compartilhados pelas telas
// que listam prompts (Configuração de Prompts do admin e Prompts dos capítulos da conta).
export const STAGE_LABELS = {
  "__global__": "Global",
  "introduction_intro": "1. Introdução ao Plano",
  "introduction_history": "1.1 Histórico",
  "introduction_importance": "1.2 Importância",
  "introduction_objectives": "1.3 Objetivos",
  "characterization_location": "2.1 Localização",
  "characterization_vegetation": "2.2.1 Vegetação",
  "characterization_hydrography": "2.2.2 Hidrografia",
  "characterization_soil": "2.2.3 Solo",
  "characterization_climate": "2.3 Clima",
  "characterization_population": "2.4 População",
  "characterization_socioeconomic": "2.5 Socioeconômico",
  "characterization_urban_area": "2.6 Malha Urbana",
  "characterization_legislation": "2.7 Legislação",
  "participatory_diagnosis_methodology": "3.1 Metodologia utilizada",
  "participatory_diagnosis_results": "3.2 Resultados encontrados",
  "forest_inventory_methodology": "4.1 Metodologia Utilizada",
  "forest_inventory_general_quantitative": "4.2.1 Quantitativo Geral",
  "forest_inventory_dendrometric_variables": "4.2.2 Variáveis Dendrométricas",
  "forest_inventory_species": "4.2.3 Espécies Encontradas",
  "forest_inventory_origin": "4.2.4 Origem das Espécies",
  "forest_inventory_threatened_species": "4.2.5 Espécies Ameaçadas e/ou Endêmicas",
  "forest_inventory_relevant_species": "4.2.6 Espécie Relevante",
  "forest_inventory_main_problems": "4.3 Principais Problemas Encontrados",
  "forest_inventory_gaau_index": "4.4 Índice GAAU – Grau de Atenção para Árvores Urbanas",
  "urban_planning_intro": "5. Planejamento da Arborização Urbana",
  "urban_planning_spaces": "5.1 Espaços e Ambientes",
  "urban_planning_planting_criteria": "5.2 Critérios de Plantio",
  "urban_planning_sidewalk_width": "5.2.1 Largura do Passeio",
  "urban_planning_property": "5.2.2 Imóvel",
  "urban_planning_electrical": "5.2.3 Rede Elétrica",
  "urban_planning_road_use": "5.2.4 Uso da Via",
  "urban_planning_urban_furniture": "5.2.5 Mobiliário Urbano",
  "urban_planning_spacing": "5.2.6 Espaçamento entre Árvores",
  "urban_planning_tree_characteristics": "5.3 Características Gerais das Árvores",
  "urban_planning_tree_size": "5.3.1 Porte das Árvores",
  "urban_planning_crown_architecture": "5.3.2 Arquitetura de Copa",
  "urban_planning_flowers_fruits": "5.3.3 Flores e Frutos",
  "urban_planning_roots": "5.3.4 Raízes",
  "urban_planning_trunk": "5.3.5 Tronco",
  "urban_planning_origin": "5.4 Origem – Nativas e Exóticas",
  "urban_planning_species": "5.5 Critério de Escolha de Espécies",
  "urban_planning_indicated_species": "5.6 Espécies Indicadas",
  "urban_planning_toxic_plants": "5.7.1 Plantas Tóxicas",
  "urban_planning_invasive_species": "5.7.2 Espécies Exóticas Invasoras",
  "urban_planning_priority_areas": "5.8 Áreas Prioritárias",
  "implementation_intro": "6. Implantação da Arborização",
  "implementation_seedling_characteristics": "6.1 Características das Mudas",
  "implementation_seedling_sourcing": "6.2 Obtenção de Mudas",
  "implementation_own_nursery_production": "6.2.1 Produção em Viveiro Próprio",
  "implementation_commercial_seedling_acquisition": "6.2.2 Aquisição Comercial",
  "implementation_seedling_donation": "6.2.3 Doação de Mudas",
  "implementation_planting_procedures": "6.3 Procedimentos de Plantio",
  "implementation_post_planting_actions": "6.4 Ações Pós-Plantio",
  "implementation_monitoring": "6.5 Monitoramento do Plantio",
  "implementation_planting_registration": "6.6 Cadastramento dos Plantios",
  "implementation_awareness_campaign": "6.7 Campanha de Conscientização",
  "maintenance_intro": "7. Manutenção da Arborização",
  "maintenance_pruning": "7.1 Poda",
  "maintenance_pruning_types": "7.1.1 Tipos de Poda",
  "maintenance_three_cuts_technique": "7.1.2 Técnica dos Três Cortes",
  "maintenance_removal_replacement": "7.2 Remoção e Substituição",
  "maintenance_pruning_tools": "7.3 Ferramentas de Poda",
  "maintenance_waste_disposal": "7.4 Destinação de Resíduos",
  "maintenance_tree_transplant": "7.7 Transplante de Árvores e Palmeiras",
  "maintenance_technical_responsibility": "7.8 Responsabilidade Técnica",
  "fall_risk_assessment_levels": "8.1 Níveis de Avaliação de Risco",
  "fall_risk_assessment_methodology": "8.2 Metodologia para Avaliação de Risco de Queda",
  "fall_risk_technical_responsibility": "8.3 Responsabilidade Técnica",
  "monitoring": "10. Monitoramento",
  "protected_trees": "11. Árvores Imunes ao Corte",
  "participatory_workshop": "12. Workshop Participativo",
  "strategic_axes": "13. Eixos Estratégicos e Plano de Ação",
  "public_hearing": "14. Audiência Pública",
  "annexes_qa": "16. Assistente de Busca em Anexos",
};

// Ordem oficial dos capítulos = ordem de inserção em STAGE_LABELS (numérica: 1.1, 1.2, …,
// 2.1, …, 10, 11 …). Usada para ordenar selects/tabela por capítulo em vez de alfabética.
export const STAGE_ORDER = Object.keys(STAGE_LABELS).reduce((acc, code, i) => {
  acc[code] = i;
  return acc;
}, {});

export function compararEtapa(a, b) {
  const ia = STAGE_ORDER[a] !== undefined ? STAGE_ORDER[a] : Number.MAX_SAFE_INTEGER;
  const ib = STAGE_ORDER[b] !== undefined ? STAGE_ORDER[b] : Number.MAX_SAFE_INTEGER;
  if (ia !== ib) return ia - ib;
  return (STAGE_LABELS[a] || a).localeCompare(STAGE_LABELS[b] || b, "pt-BR");
}
